<template>
  <div v-if="html" class="rich-text" v-html="html"></div>
</template>
<script>
import { safeHtml } from '@/services/contentApi';
export default {
  name: 'RichText',
  props: { value: { default: '' } },
  computed: {
    html() {
      return safeHtml(this.value);
    },
  },
};
</script>
